import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { satoshi700 } from "../../../../styles/font.constants";

export const Container = styled.div`
	display: flex;
	justify-content: space-between;
`;

type MinuteStyleProps = {
	$color?: string;
};

export const Minute = styled.div<MinuteStyleProps>`
	${satoshi700}
	font-size: 1.35rem;
	color: ${({ $color = colours.black }) => $color};
	margin-top: 0.1rem;
`;

export const IconTitle = styled.div`
	display: flex;
	gap: 0.7rem;
`;

export const Logo = styled.img`
	width: 32px;
	height: 32px;
	border-radius: 100%;
	border: solid 1px ${colours.greyDark};
	object-fit: cover;
	flex-shrink: 0;
`;
